import { render } from "./page-bonus.vue?vue&type=template&id=186d22e8&scoped=true"
import script from "./page-bonus.vue?vue&type=script&lang=js"
export * from "./page-bonus.vue?vue&type=script&lang=js"

import "./page-bonus.vue?vue&type=style&index=0&id=186d22e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186d22e8"]])

export default __exports__